export interface AppConfig {
  apiUrl: string;
  cognitoDomain: string;
  clientId: string;
  redirectUri: string;
  // Deployment stage from CDK, e.g. 'Dev', 'Gamma', 'Prod'. Empty for
  // config.json files deployed before the stage was included.
  stage: string;
}

let cachedConfig: AppConfig | null = null;

export async function getConfig(): Promise<AppConfig> {
  if (cachedConfig) return cachedConfig;
  const resp = await fetch('/config.json');
  const json = await resp.json();
  cachedConfig = {
    apiUrl: json.apiUrl,
    cognitoDomain: json.cognitoDomain,
    clientId: json.clientId,
    redirectUri: window.location.origin + '/',
    stage: json.stage || '',
  };
  return cachedConfig;
}

export function isProductionStage(stage: string): boolean {
  // Treat unknown/missing stage as production to avoid a false-alarm
  // banner on prod if config.json predates the stage field.
  return !stage || stage.toLowerCase() === 'prod' || stage.toLowerCase() === 'production';
}
